import './_product-images.scss';
import component from './product-images';

export default component;
